import { render, staticRenderFns } from "./DenunciaFormDatos.vue?vue&type=template&id=271238a2&scoped=true"
import script from "./DenunciaFormDatos.vue?vue&type=script&lang=js"
export * from "./DenunciaFormDatos.vue?vue&type=script&lang=js"
import style0 from "./DenunciaFormDatos.vue?vue&type=style&index=0&id=271238a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271238a2",
  null
  
)

export default component.exports